var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Field } from 'react-final-form';
import { StyledInputLabel, InputElementHeading } from '../elements';
import { Input } from '../input/input';
import { isEmailValid } from '../../validators';
import AccessibilityHelper from '../accessibilityHelper';
import elementStyles from '../elements.module.scss';
var InputEmail = function (_a) {
    var hint = _a.hint, id = _a.id, input = _a.input, label = _a.label, meta = _a.meta, name = _a.name, placeholder = _a.placeholder, readOnly = _a.readOnly, required = _a.required, testId = _a.testId, cfg = _a.cfg;
    var helper = new AccessibilityHelper(name, !!label, !!hint);
    return (React.createElement(StyledInputLabel, { isError: meta && meta.touched && meta.error, cfg: Object.assign({ mt: 1 }, cfg) },
        React.createElement(InputElementHeading, { label: label, required: required, hint: hint, meta: meta, accessibilityHelper: helper }),
        React.createElement(Input, __assign({ id: id, type: "email", autoComplete: "email", className: elementStyles.emailInput, testId: testId, label: label, required: required, placeholder: placeholder, readOnly: readOnly, isError: meta && meta.touched && meta.error, accessibilityHelper: helper }, input))));
};
export var FFInputEmail = React.forwardRef(function (fieldProps, ref) {
    return (React.createElement(Field, __assign({}, fieldProps, { validate: isEmailValid(fieldProps.errorEmptyValue, fieldProps.errorInvalidValue, fieldProps.required), render: function (props) { return React.createElement(InputEmail, __assign({}, props, fieldProps, { ref: ref })); } })));
});
//# sourceMappingURL=email.js.map